import React from "react";
import ParameterProgressBar from "./ParameterProgressBar";

export default function TendencyNumbers({ numbers }) {
  return (
    <div>
      <ParameterProgressBar name="Uçlara Yönelim" score={numbers?.edgeLean} />
      <ParameterProgressBar name="Yüksek Uca Yönelim" score={numbers?.highLean} />
      <ParameterProgressBar name="Düşük Uca Yönelim " score={numbers?.lowLean} />
      <ParameterProgressBar name="Ortalara Yönelim" score={numbers?.middleLean} />
    </div>
  );
}
